import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Learn Computational Thinking Through Robotics</h1>
        <p>Build, program, and control your own robot with our easy-to-use block-based programming platform.</p>
      </div>
    </section>
  );
};

export default Hero;